<template>
  <div class="bg-black  px-lg-5 text-white">
    <div class="my-padding">
      <h3 class="my-font my-color mt-3 mb-4">سوالات متداول</h3>

      <div>
        <h3 class="my-font my-color mt-5 mb-3">1.تفاوت خوراک زنبور کوپابی با سایر برندهای بازار چیست؟</h3>
        <div class="img-section row justify-content-center">
          <img class="col-12 col-lg-5 mx-auto my-3 " src="/img/faq1.png" alt="">
        </div>

        <p>
          خوراک زنبور کوپابی برخلاف بسیاری از محصولات موجود در بازار که به‌صورت فوندانت (خمیر شکر) عرضه می‌شوند، به شکل
          نیمه‌جامد (Semi-solid) تولید شده است.
          <br>
          این ویژگی چند مزیت کلیدی را به همراه دارد:
          <br>
          <b>سهولت مصرف برای زنبور:</b>
           ساختار نیمه‌جامد محصول با آناتومی دهان زنبور سازگارتر است و باعث مصرف آسان‌تر خوراک
          می‌شود.
          <br>
          <b>کاهش مصرف انرژی:</b>
           زنبور برای استفاده از خوراک نیازی به حل کردن آن با آب ندارد، در نتیجه انرژی کمتری مصرف
          می‌کند.
          این موضوع به‌ویژه در فصول سرد اهمیت زیادی دارد.
          <br>
          <b>جلوگیری از غرق‌شدگی:</b>
           به دلیل چگالی و قوام مناسب، زنبورها در محصول غرق نمی‌شوند؛ چه در حالت بسته‌بندی و چه
          زمانی
          که خوراک روی قاب قرار داده شود.
          <br>
          <b>افزایش نرخ مصرف:</b>
           خوراک نیمه‌جامد سریع‌تر مصرف می‌شود و در نتیجه رشد و توسعه توده زنبوری تسریع یافته و چرخه
          کلنی
          پایدارتر می‌ماند.
          <br>
          <b>عدم باقی‌مانده:</b>
           پس از مصرف، هیچ‌گونه پسماندی در کف کندو یا داخل بسته باقی نمی‌ماند.
          <br>
          <b>عدم خشک‌شدن سطح خوراک:</b>
           پس از باز شدن بسته‌بندی، لایه‌ی سطحی خوراک خشک نمی‌شود و ماندگاری بالایی دارد.
          <br>
          <b>  تولید علمی و دانش‌بنیان:</b>
          فرمولاسیون کوپابی با همکاری پژوهشگران دانشگاه شهید بهشتی و بر پایه تحقیقات R&D تهیه شده است. در این فرایند،
          پیوندهای شیمیایی قندها شکسته و به قندهای ساده‌ و موردنیاز بدن زنبور مانند گلوکز تبدیل شده‌اند.
          <br>

        </p>
        <b> سایر مزایا:</b>
        <ul class="ps-2">
          <li> بدون هرگونه ماده‌ی شیمیایی مضر مانند HMF</li>
          <li>فاقد آلودگی‌های میکروبی و قارچی، با کنترل دقیق رطوبت، دما، اندازه ذرات بلورین و غلظت قندها</li>
          <li>قیمت‌گذاری منصفانه و اقتصادی</li>
          <!--        <li>کیفیت و عملکرد قابل‌مقایسه با نمونه‌های مطرح خارجی مانند Apipasta اسپانیایی</li>-->
        </ul>

        <div class="img-section row justify-content-center">
          <img class="col-12 col-lg-6 mx-auto my-3 " src="/img/faq2.png" alt="">
        </div>
      </div>
      <div>
        <h3 class="my-font my-color my-3">2.چگونه می‌توان محصول را سفارش داد؟</h3>
        <p>
          دو روش برای سفارش محصول وجود دارد:
          <br>
          تماس با کارشناسان فروش از طریق شماره‌های درج‌شده در بخش
          <span class="text-info cursor-pointer" @click="scroll('contact')">تماس با ما</span>
          <br>
          خرید از تعاونی‌های زنبورداری شهر یا استان محل سکونت

        </p>
      </div>

      <div>
        <h3 class="my-font my-color my-3">3.برخی از زنبورداران می‌گویند محصول شُل است؛ آیا این ایراد محسوب می‌شود؟</h3>
        <p>
          خیر. نیمه‌جامد بودن محصول یک مزیت فنی است، نه ایراد. این ویژگی باعث می‌شود خوراک سریع‌تر و کامل‌تر مصرف شود و
          بازدهی کندو افزایش یابد.
          <br>
          همچنین نحوه‌ی استفاده از این خوراک با سایر نمونه‌های بازار متفاوت است. راهنمای مصرف در بخش معرفی
          <router-link to="/product" class="text-info cursor-pointer">محصولات</router-link>
          به‌صورت کامل توضیح داده شده است.


        </p>
      </div>
      <div>
        <h3 class="my-font my-color my-3">4.قیمت محصول چقدر است؟</h3>
        <p>

          برای اطلاع از قیمت به‌روز محصول می‌توانید:
          <br>
          با کارشناسان فروش
          <a href="tel:09125802203" class="text-info cursor-pointer">تماس</a>
          بگیرید
          <br>
          از طریق لینک

          <a target="_blank" href="https://wa.me/989125802203" class="text-info cursor-pointer">واتساپ</a>
          و
          <a target="_blank" href="https://t.me/Copabee1" class="text-info cursor-pointer">تلگرام</a>
          درج‌شده در سایت اقدام نمایید.

        </p>
      </div>
      <div>
        <h3 class="my-font my-color my-3">5. بهترین زمان مصرف این خوراک چه موقع است؟</h3>
        <p>

          خوراک کوپابی در بازه‌های زمانی زیر بهترین عملکرد را دارد:
          <br>
          <b>اوایل بهار:</b>
          زمانی که هوا هنوز سرد است و امکان تغذیه با شربت وجود ندارد. مصرف کوپابی در این زمان باعث شروع
          به‌موقع تخم‌ریزی ملکه می‌شود.
          <br>
          <b>پاییز:</b>
          برای تأمین ذخایر غذایی زمستانی کلنی
          <br>
          <b>پیش از برداشت عسل:</b>
          1 تا 2 روز قبل از برداشت برای جلوگیری از استرس تغذیه‌ای در زنبورها و جایگزینی سریع خوراک پس
          از برداشت.
          <br>
          <b>پس از برداشت عسل:</b>
          به‌عنوان جایگزین شهد و منبع انرژی بدون تأثیر منفی بر کیفیت عسل؛ چرا که این محصول دارای حداقل
          میزان ساکارز است
          زمان کمبود شهد در منطقه یا کندو
        </p>
      </div>
      <div>
        <h3 class="my-font my-color my-3">6. ترکیبات تشکیل‌دهنده خوراک کوپابی چیست؟</h3>
        <p>

          با توجه به حساسیت زنبورعسل نسبت به ترکیبات تغذیه‌ای، این محصول تنها از مواد طبیعی و مؤثر ساخته شده است.
          <br>
          ترکیبات اصلی شامل:
          <br>
          قندهای ساده‌ی مورد نیاز آناتومی بدن زنبورعسل
          <br>
          مشتقات قندهای هیدرولیز شده
          <br>
          بدون استفاده از رنگ، اسانس، مواد نگهدارنده یا ترکیبات شیمیایی مضر
          <br>
          مشخصات کامل ترکیبات در پشت بسته‌بندی محصول درج شده است:

        </p>
        <div class="img-section row justify-content-center">
          <img class="col-12 col-lg-4 mx-auto my-3 " src="/img/faq3.png" alt="">
        </div>
      </div>
      <div>
        <h3 class="my-font my-color my-3">7.آیا محصول حاوی گرده گل یا ترکیبات تقویتی هم دارید؟</h3>
        <p>
          بله. محصول ویژه شرکت با نام "کوپابی اولترا" در حال حاضر در مرحله تست کلینیکی روی کلنی‌های همکاران زنبوردار
          قرار دارد.
          <br>
          ویژگی‌های این محصول:

          حاوی گرده گل طبیعی (ضدعفونی‌شده با اشعه گاما و بهینه‌سازی‌شده)
          <br>
          تقویت‌شده با ویتامین‌ها و عناصر معدنی ضروری برای زنبور
          <br>
          طراحی‌شده بر اساس ساختار فیزیولوژیکی زنبور عسل
          <br>
          مناسب برای استفاده در فصول حساس و دوره‌های بحرانی کلنی
        </p>
        <div class="img-section row justify-content-center">
          <img class="col-6 col-lg-3 my-3 " src="/img/faq4.png" alt="">
          <img class="col-6 col-lg-3 my-3 " src="/img/faq5.jpg" alt="">
        </div>

      </div>


    </div>
  </div>
</template>

<script>

export default {
  name: "Faq",
  setup(){

    const scroll = (id)=>{
      document.getElementById(id)?.scrollIntoView();
    }
    return{
      scroll,
    }
  }
}
</script>

<style scoped>
p{
  text-align: justify-all !important;
}
</style>